<template>
	<div>
		<div class="u-container">
			<FindIdForm v-if="page === 1" @nextPage="nextPage"></FindIdForm>
			<FindIdResult v-if="page === 2"></FindIdResult>
		</div>
	</div>
</template>

<script>
import FindIdForm from './form';
import FindIdResult from './result';

export default {
	components: {
		FindIdForm,
		FindIdResult,
	},
	data() {
		return {
			page: 1,
		};
	},
	methods: {
		nextPage() {
			this.page++;
		},
	},
};
</script>
